/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { ParamedicType } from 'app/shared/model/enumerations/paramedic-type.model';

export interface IParamedic {
  id?: string;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  name?: string;
  email?: string;
  visitCharge?: number;
  age?: number | null;
  gender?: keyof typeof Gender | null;
  mobile?: string | null;
  dateOfBirth?: number | null;
  bloodGroup?: keyof typeof BloodGroup | null;
  paramedicType?: keyof typeof ParamedicType | null;
  registrationCode?: string | null;
  registrationNumber?: string | null;
  registrationValidUpto?: number | null;
  knownLanguages?: string | null;
  qualification?: string | null;
  practicingCity?: string;
  user?: IUser;
  contactCode?: IContactDetails;
}

export const defaultValue: Readonly<IParamedic> = {
  active: false,
};
